import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import GoogleAnalytics from './GoogleAnalytics';
import * as serviceWorker from './serviceWorker';
import { cleanURLParams } from "./CleanQueryParams";
import { Amplify } from 'aws-amplify';


Amplify.configure({
  Auth: {
    userPoolId: process.env.REACT_APP_COGNITO_GROUP_ID,
    userPoolWebClientId: process.env.REACT_APP_COGNITO_CLIENT_ID,
    cookieStorage: {
      domain: '.innovaschools.edu.pe', 
      path: '/',
      expires: 365,
      secure: true,
      sameSite: 'lax'
    },
    oauth: {
      domain: process.env.REACT_APP_COGNITO_DOMAIN,
      scope: ['openid', 'email', 'profile'],
      redirectSignIn: process.env.REACT_APP_COGNITO_REDIRECT_URI,
      responseType: 'token'
    }
  }
});

cleanURLParams();



ReactDOM.render(
    <React.StrictMode>
      <BrowserRouter>
        <GoogleAnalytics />
        <App />
      </BrowserRouter>
    </React.StrictMode>,
    document.getElementById('root')
  );

serviceWorker.unregister();